const Stripe = 'Stripe';
const PayPal = 'PayPal';
const PayPalCompletePayments = 'PayPalCompletePayments';
const DirectDebit = 'DirectDebit';
const StripeHostedCheckout = 'StripeHostedCheckout';
const None = 'None';
const paymentMethods = [
    Stripe,
    PayPal,
    PayPalCompletePayments,
    DirectDebit,
    StripeHostedCheckout,
    None,
];
export const isPaymentMethod = (paymentMethod) => {
    return (typeof paymentMethod === 'string' && paymentMethods.includes(paymentMethod));
};
export function toPaymentMethodSwitchNaming(paymentMethod) {
    switch (paymentMethod) {
        case PayPal:
        case PayPalCompletePayments:
            return 'payPal';
        case Stripe:
            return 'stripe';
        case DirectDebit:
            return 'directDebit';
        case StripeHostedCheckout:
            return 'stripeHostedCheckout';
        case None:
            return null;
    }
}
export { Stripe, PayPal, PayPalCompletePayments, DirectDebit, StripeHostedCheckout, };
